import { Grid } from '@mui/material';
import { Office } from '../../models/office';
import { useLoadData } from '../../hooks/useLoadData';
import { ApiResponse } from '../../models/api-response';
import { officeApiKeyStore } from '../../api/office-api-key-store';
import { OfficeStatistics } from './office-details/widgets/office-statistics.component';
import { RecentNotes } from './office-details/widgets/recent-notes.component';
import { OfficeInfo } from './office-details/widgets/office-info.component';
import { DescriptionComponent } from './office-details/widgets/description.component';

interface WidgetsContainerProps {
  officeID?: any;
}

export const WidgetsContainer = ({ officeID }: WidgetsContainerProps) => {
  const { data, isLoading } = useLoadData<ApiResponse<Office>>(officeApiKeyStore.getOffice(officeID));
  return (
    <Grid container justifyContent="space-between" spacing={0}>
      <Grid item lg={4}>
        <OfficeStatistics officeID={officeID} />
      </Grid>
      <Grid item lg={5} sm={5} xl={5} xs={5}>
        <OfficeInfo office={data?.data} isLoading={isLoading} />
      </Grid>
      <Grid item lg={3} sm={3} xl={3} xs={3}>
        <Grid container spacing={2}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <RecentNotes officeID={officeID} />
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <DescriptionComponent office={data?.data} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
